import {
  createChatSettings as publicCreateChatSettings,
  updateChatSettings as publicUpdateChatSettings,
  deleteChatSettings as publicDeleteChatSettings,
  getChatSettings as publicGetChatSettings,
  queryChatSettings as publicQueryChatSettings,
  typedQueryChatSettings as publicTypedQueryChatSettings,
} from './forms-ai-v1-chat-settings-chat-settings.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  ChatSettingsQuery,
  ChatSettingsQueryBuilder,
  typedQueryChatSettings as universalTypedQueryChatSettings,
} from './forms-ai-v1-chat-settings-chat-settings.universal.js';
import { onChatSettingsCreated as publicOnChatSettingsCreated } from './forms-ai-v1-chat-settings-chat-settings.public.js';
import { onChatSettingsDeleted as publicOnChatSettingsDeleted } from './forms-ai-v1-chat-settings-chat-settings.public.js';
import { onChatSettingsUpdated as publicOnChatSettingsUpdated } from './forms-ai-v1-chat-settings-chat-settings.public.js';

function customQueryChatSettings(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryChatSettings(httpClient)(),
    typedQueryFunction: (query: ChatSettingsQuery) =>
      publicTypedQueryChatSettings(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): ChatSettingsQueryBuilder;
  function overloadedQuery(
    query: ChatSettingsQuery
  ): ReturnType<typeof universalTypedQueryChatSettings>;
  function overloadedQuery(query?: ChatSettingsQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createChatSettings: MaybeContext<
  BuildRESTFunction<typeof publicCreateChatSettings> &
    typeof publicCreateChatSettings
> = /*#__PURE__*/ createRESTModule(publicCreateChatSettings);
export const updateChatSettings: MaybeContext<
  BuildRESTFunction<typeof publicUpdateChatSettings> &
    typeof publicUpdateChatSettings
> = /*#__PURE__*/ createRESTModule(publicUpdateChatSettings);
export const deleteChatSettings: MaybeContext<
  BuildRESTFunction<typeof publicDeleteChatSettings> &
    typeof publicDeleteChatSettings
> = /*#__PURE__*/ createRESTModule(publicDeleteChatSettings);
export const getChatSettings: MaybeContext<
  BuildRESTFunction<typeof publicGetChatSettings> & typeof publicGetChatSettings
> = /*#__PURE__*/ createRESTModule(publicGetChatSettings);
export const queryChatSettings: MaybeContext<
  BuildRESTFunction<typeof customQueryChatSettings> &
    typeof customQueryChatSettings
> = /*#__PURE__*/ createRESTModule(customQueryChatSettings);
/** */
export const onChatSettingsCreated: BuildEventDefinition<
  typeof publicOnChatSettingsCreated
> &
  typeof publicOnChatSettingsCreated = createEventModule(
  publicOnChatSettingsCreated
);
/** */
export const onChatSettingsDeleted: BuildEventDefinition<
  typeof publicOnChatSettingsDeleted
> &
  typeof publicOnChatSettingsDeleted = createEventModule(
  publicOnChatSettingsDeleted
);
/** */
export const onChatSettingsUpdated: BuildEventDefinition<
  typeof publicOnChatSettingsUpdated
> &
  typeof publicOnChatSettingsUpdated = createEventModule(
  publicOnChatSettingsUpdated
);

export {
  Personality,
  SortOrder,
  WebhookIdentityType,
} from './forms-ai-v1-chat-settings-chat-settings.universal.js';
export {
  ChatSettings,
  ExtendedFields,
  CreateChatSettingsRequest,
  CreateChatSettingsResponse,
  UpdateChatSettingsRequest,
  UpdateChatSettingsResponse,
  DeleteChatSettingsRequest,
  DeleteChatSettingsResponse,
  GetChatSettingsRequest,
  GetChatSettingsResponse,
  QueryChatSettingsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryChatSettingsResponse,
  CursorPagingMetadata,
  Cursors,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  ChatSettingsCreatedEnvelope,
  ChatSettingsDeletedEnvelope,
  ChatSettingsUpdatedEnvelope,
  UpdateChatSettings,
  ChatSettingsQueryResult,
  ChatSettingsQueryBuilder,
  ChatSettingsQuerySpec,
} from './forms-ai-v1-chat-settings-chat-settings.universal.js';
export { utils } from './forms-ai-v1-chat-settings-chat-settings.universal.js';
export {
  PersonalityWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CommonQueryWithEntityContext,
  ChatSettingsQuery,
} from './forms-ai-v1-chat-settings-chat-settings.universal.js';
